function WOTCModalService() {

}

window.wotcModalService = new WOTCModalService();

(function (angular) {

    "use strict";

    angular.module('harriMainApp').controller("WotcModalController", WotcModalController);

    WotcModalController.$inject = ["$scope", "modalData", "$filter", "onSuccess", "wotcDataService","onOptOut" ,"onClose"];

    function WotcModalController($scope, modalData, $filter, onSuccess, wotcDataService, onOptOut, onClose) {

        var self = this;
        var brandId = modalData.brandId;
        self.applicationId = modalData.appId;
        self.prospectId = modalData.prospectId;
        self.wotcForce = modalData.wotcForce;
        self.afterJobApply = modalData.afterJobApply;
        self.loading = true;
        self.backgroundMedia = {};

        self.WOTC_STEPS = {
            APPLICANT_DATA_CONFIRMATION: 'APPLICANT_DATA_CONFIRMATION',
            SCREENING: 'SCREENING',
            SIGNING: 'SIGNING'
        };

        window.wotcModalService.closeModal = () => {
            wotcDataService.wotcCloseModal();
            onSuccess && onSuccess();
            $scope.$hide();
            $scope.$digest();
        };

        var init = function () {
            self.validScreening = true;
            wotcDataService.getBrandWotcSettings(brandId)
                .then(function (settings) {
                    if (_.isEmpty(settings)) {
                        self.validScreening = false;
                        self.loading = false;
                        self.notValidMsg = $filter("translate")("The screening is no longer valid.") +'</br>'+ $filter("translate")("Please contact the hiring manager to complete the WOTC screening.");
                        $scope.$digest();
                    }
                    else {
                        wotcDataService.getCandidateScreenings([wotcDataService.WOTC_STATUS.ELIGIBLE,wotcDataService.WOTC_STATUS.NOT_ELIGIBLE,wotcDataService.WOTC_STATUS.OPT_OUT])
                            .then(function (res) {
                                if(self.prospectId) {
                                    var prospectsScreening = res.prospects;
                                    if (prospectsScreening.length > 0) {
                                        var candidateScreening = _.find(prospectsScreening, function (item) {
                                            return (item.prospect.id == self.prospectId &&
                                                item.prospect.brand_id == brandId)
                                        });
                                        if (candidateScreening) {
                                            self.validScreening = false;
                                        }
                                    }
                                }
                                else {
                                    var applications = res.applications;
                                    if (applications.length > 0) {
                                        var candidateScreening = _.find(applications, function (item) {
                                            return (item.job_application.id == self.applicationId &&
                                                item.job_application.job.brand_id == brandId)
                                        });
                                        if (candidateScreening) {
                                            self.validScreening = false;
                                        }
                                    }
                                }
                                if(self.validScreening) {
                                    self.activeStep = self.WOTC_STEPS.APPLICANT_DATA_CONFIRMATION;
                                    self.provider = settings['provider'];
                                    self.brandId = brandId;
                                    ProfileAPI.getBrandProfile(brandId)
                                        .then(function (brand) {
                                            self.brandDetails = brand;
                                            self.backgroundMedia = _.findWhere(self.brandDetails.BrandMedia, {'type': 'background_image'});
                                            self.loading = false;
                                            $scope.$digest();
                                        })
                                        .catch(function (err) {
                                            self.loading = false;
                                            console.error(err);
                                            $scope.$digest();
                                        })
                                }
                                else {
                                    self.loading = false;
                                    self.notValidMsg = $filter("translate")("You have already completed the screening.");
                                    $scope.$digest();
                                }
                            });
                    }
                })
        };

        self.close = function () {
            wotcDataService.wotcCloseModal();
            $scope.$hide();
            onClose && onClose();
        };

        var goNextStep = function (stepCode) {
            self.activeStep = self.WOTC_STEPS[stepCode];
        };

        self.submit = function (haveNextStep, response) {
            if(haveNextStep) {
                switch (self.activeStep) {
                    case self.WOTC_STEPS.APPLICANT_DATA_CONFIRMATION:
                        goNextStep(self.WOTC_STEPS.SCREENING);
                        self.screeningMode = response['screening_mode'];
                        if (self.screeningMode  === 'QUESTIONNAIRE') {
                            self.screeningDetails = response['next_questionnaire'];
                        }
                        else if (self.screeningMode == 'EXTERNAL_LINK') {
                            self.screeningDetails = response['screening_link'];
                        }

                        self.screeningId = response['id'];
                        break;

                    case self.WOTC_STEPS.SCREENING:
                        goNextStep(self.WOTC_STEPS.SIGNING);
                        break;
                }

            }
            else {
                $scope.$hide();
                onSuccess && onSuccess();
            }
        };

        self.optOut = function () {

            hConfirm({
                title: "Opt Out Screening",
                text: "Are you sure you want to Opt Out screening?",
                confirmButton: "Yes",
                cancelButton: "No",
                callback: function (confirmed) {
                    if (confirmed) {
                        $scope.$hide();
                        wotcDataService.optOutScreening(self.brandId, self.applicationId, self.prospectId)
                            .then(function () {
                                onOptOut && onOptOut();
                            })
                            .catch((err) => {
                                onOptOut && onOptOut();
                            })
                    }
                    setTimeout(function () {
                        $scope.$digest();
                    }, 1);

                }
            });

        };

        init();
    }
})(angular);